var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GlobalToolbar',{attrs:{"headerProps":_vm.headerProps}}),_c('SearchBar',{attrs:{"search":_vm.search,"items":_vm.items},on:{"handleSearch":_vm.handleSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }